import { makeStyles } from "@material-ui/styles";

export const drawerWidth = 300;

export default makeStyles(theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  headerIcon: {
    "&:hover": {
      backgroundColor: "#F0F4FF", // Light blue background for active item
      borderRadius: "8px", // Rounded edges
      "& .MuiListItemText-primary": {
        color: "#42497E", // Blue text for active item
        fontWeight: 600, // Bold text for active item
      },
    },
    
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 40,
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
    },
  },
  toolbar: {
   paddingTop: theme.spacing(3)
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  /* sidebarList: {
    marginTop: theme.spacing(6),
  }, */
  mobileBackButton: {
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(0.625),
    },
    [theme.breakpoints.up("md")]: {
    },
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "100%", // Ensure the container doesn't overflow
    "&:hover": {
      backgroundColor: "#F0F4FF", // Light blue background for active item
      borderRadius: "8px", // Rounded edges
      "& .MuiListItemText-primary": {
        color: "#42497E", // Blue text for active item
        fontWeight: 600, // Bold text for active item
      },
    },
    
  },
  logoImage: {
    width: "200px",
    height: "auto", // Maintain aspect ratio
    objectFit: "contain", // Ensure the image fits within the container without stretching
    marginRight: '10px'
  },  
  logoutBox:{
    position:"absolute",
    bottom:"0",
    width:"100%",
   
    padding: 10,
  
  },
  logoutContent: {
    display:'flex',
    justifyContent:'space-between',
    alignItems: "center"
  },
  logoutContent2: {
    display:'flex',
    justifyContent:'center',
    alignItems: "center",
    width: "100%"
  },
 
  divider: {
    marginBottom: "10px"
  },
  titleText:{
    padding: 0,
    color: "#344054",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
    fontWeight: 600,
  },
  text:{
    padding: 0,
    color: "#344054",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  },
   logoutTextBox: {
    display: "flex",
    gap:"0px",
    flexDirection: "column",

   }
}));
